import React from 'react'
import { Badge, CircularProgress, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { format, } from 'date-fns'
import DeleteIcon from '@material-ui/icons/Delete';
import BackupOutlinedIcon from '@material-ui/icons/BackupOutlined';
import ActiveIcon from '../assets/icons/folderstatus_3.png'
import FinishedIcon from '../assets/icons/folderstatus_4.png'
import ClosedIcon from '../assets/icons/folderstatus_5.png'
import { useStore } from '../Store'

const VisitList = ({ onSelect, onDelete, visits, loading }) => {
  const { plots } = useStore()
  const plotDescription = (plot) => {
    let description = plot.description
    if (plot.parentId) {
      const parent= plots.find(p => p.id === plot.parentId)
      if (parent) {
        description= `${parent.description} / ${plot.description}`
      }
    }
    return description
  }

  return (
    <>
      <List component="nav" aria-label="bezoeken" style={{ marginBottom: '57px' }}>
        {visits && visits.length > 0 ?
          visits.map((item, i) => (
            <ListItem button key={item.id} onClick={(e) => onSelect(item)} divider>
              <ListItemIcon style={{minWidth:40}} >
              {item.statusId === 3 && <img src={ActiveIcon} alt='' />}
              {item.statusId === 4 && <img src={FinishedIcon} alt='' />}
              {item.statusId === 5 && <img src={ClosedIcon} alt='' />}
              </ListItemIcon>
              <ListItemText primary={format(new Date(item.timeStart), 'dd-MM-yyyy')} secondary={plotDescription(item.plot)} />
              <ListItemSecondaryAction>
                {item.offline && 
                <IconButton aria-label="upload" disabled>
                  <BackupOutlinedIcon color={item.error?'error':'primary'} />
                </IconButton>
                }
                {item.statusId === 3 &&
                  <IconButton aria-label="delete" onClick={(e) => onDelete(item)} >
                    <DeleteIcon />
                  </IconButton>
                }
                <Badge color="primary" badgeContent={item.observations.filter(o => o.delstaId===0).length} max={99} showZero></Badge>
              </ListItemSecondaryAction>
            </ListItem>
          ))
          : (loading === true ? <CircularProgress size={20} /> : <p><i>Geen resultaten</i></p>)}
      </List>
    </>
  )
}

export default VisitList
